// @see App/Models/Seo/SlugLocation.php::CURRENT_LOCATION_SLUG
export const CurrentLocationSlugs = [
  'current-location',
  'aktueller-standort',
  'locația-curentă',
  'posizione-attuale',
];
